module.exports = __webpack_public_path__ + "static/dot-bg-696d69688a4350071d352f80fc0b9677.png";